





















import {Vue, Component, Prop, Emit} from "vue-property-decorator";

@Component
export default class SendSiosQuestion extends Vue {
    opened = false;
    description = "";
    sioCount = 0;

    async ask(description: string, sioCount: number) {
        this.description = description;
        this.sioCount = sioCount;
        this.opened = true;
        
    }


    @Emit("send-sios-answer")
    answer(send: boolean) {
        this.opened = false;
    }

    yes() {
        this.answer(true);
    }
    no() {
        this.answer(false);
    }
}
